import IFilmnytt, { DocType_Filmnytt } from "src/lib/types/Filmnytt";
import { PublishableDocument } from "src/lib/types/IForsidenV2";

export function isAdContent(document: PublishableDocument | null | undefined): boolean {
    if (document) {
        return document._type === DocType_Filmnytt && !!(document as IFilmnytt).isAdContent;
    }
    return false;
}
